// extracted by mini-css-extract-plugin
module.exports = {"UserBox":"UserBox_UserBox__2r27l","Row":"UserBox_Row__2rzum"};